var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMikeIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1865C1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_3020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 11C19.204 11 18.441 11.3161 17.8784 11.8787C17.3158 12.4413 16.9997 13.2044 16.9997 14V18C16.9997 18.7956 17.3158 19.5587 17.8784 20.1213C18.441 20.6839 19.204 21 19.9997 21C20.7953 21 21.5584 20.6839 22.121 20.1213C22.6836 19.5587 22.9997 18.7956 22.9997 18V14C22.9997 13.2044 22.6836 12.4413 22.121 11.8787C21.5584 11.3161 20.7953 11 19.9997 11ZM19.9997 9C20.6563 9 21.3065 9.12933 21.9131 9.3806C22.5197 9.63188 23.0709 10.0002 23.5352 10.4645C23.9995 10.9288 24.3678 11.48 24.6191 12.0866C24.8704 12.6932 24.9997 13.3434 24.9997 14V18C24.9997 19.3261 24.4729 20.5979 23.5352 21.5355C22.5975 22.4732 21.3258 23 19.9997 23C18.6736 23 17.4018 22.4732 16.4642 21.5355C15.5265 20.5979 14.9997 19.3261 14.9997 18V14C14.9997 12.6739 15.5265 11.4021 16.4642 10.4645C17.4018 9.52678 18.6736 9 19.9997 9ZM11.0547 19H13.0697C13.312 20.6648 14.1456 22.1867 15.4179 23.2873C16.6903 24.3879 18.3164 24.9936 19.9987 24.9936C21.681 24.9936 23.3071 24.3879 24.5795 23.2873C25.8518 22.1867 26.6854 20.6648 26.9277 19H28.9437C28.7163 21.0287 27.8063 22.9199 26.3629 24.3635C24.9195 25.8071 23.0284 26.7174 20.9997 26.945V31H18.9997V26.945C16.9708 26.7176 15.0795 25.8074 13.6359 24.3638C12.1923 22.9202 11.2821 21.0289 11.0547 19Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_3020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikeIcn);
export default __webpack_public_path__ + "static/media/mike-icn.9b790596cde6dc8bffb1ce31e8c0a897.svg";
export { ForwardRef as ReactComponent };